import { IStackProps } from '@fluentui/react';

export const topStackStyles: Partial<IStackProps> = {
    tokens: { childrenGap: 15, padding: '0 0 0 0' },
};
